import script from "./XL.vue?vue&type=script&setup=true&lang=js"
export * from "./XL.vue?vue&type=script&setup=true&lang=js"

import "./XL.vue?vue&type=style&index=0&id=bbb0ece0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbb0ece0"]])

export default __exports__